module.exports = __webpack_public_path__ + "static/img/pay-success.7ce95142.png";